module.exports = __webpack_public_path__ + "static/img/banner4.66a45c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner4.png
// module id = F0uR
// module chunks = 12